import React from 'react'

class SelectBox extends React.Component {
  onChange = () => {
    const {
      onChange,
      value,
      disabled
    } = this.props;

    if (!disabled) {
      onChange(value)
    }
  }

  activeClass = () => {
    return (this.props.checked ? 'active' : null)
  }

  disabledClass = () => {
    return (this.props.disabled ? 'disabled' : null)
  }

  render() {
    const {
      value,
      checked,
      name,
      text,
      boxStatus,
      disabled,
      style
    } = this.props

    return (
      <div
        onClick={ this.onChange }
        className={`card card-border card-btn ${this.activeClass()} ${this.disabledClass()} mr-2 ${style}`}
      >
        <div className='custom-control custom-radio'>
          <input
            className='custom-control-input'
            readOnly={ disabled }
            type='radio'
            name={name}
            onChange={ this.onChange }
            value={value}
            checked={ checked }
          />
          <label className='custom-control-label'>{text}</label>
        </div>
      </div>
    )
  }
}

export default SelectBox;
